// @flow

export const DESKTOP: string = '@media (max-width: 1200px)'
export const TABLET: string = '@media (max-width: 1024px)'
export const MOBILE: string = '@media (max-width: 540px)'
